'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.heights = {
  init: function init(p) {
    _n3.default.qsa('.h-set', p || document).forEach(function (el) {
      el.style.height = el.scrollHeight + 'px';
    });
  }
};
_neptune2.default.heights.init();

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.heights;